import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import './assets/scss/socialv.scss';
import './assets/scss/custom.scss';
import './assets/scss/customizer.scss';
import './assets/scss/_socialv-custom.scss';
import 'zuck.js/dist/zuck.min.css'
import { createApp } from 'vue'

//pinia
import { createPinia } from 'pinia';

import socketIo from 'socket.io-client'

import App from './App.vue'

import './registerServiceWorker'
import router from './router'
import './plugins'
import VueSweetalert2 from 'vue-sweetalert2'
import VueApexCharts from 'vue3-apexcharts'
import BootstrapVueNext from 'bootstrap-vue-next'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'leaflet/dist/leaflet.css'
import 'swiper/scss'
// import i18n from './Utils/i18n.js'
import store from './store/index.js'; // Import your Vuex store
import eventBus from './plugins/eventBus';
import vue3GoogleLogin from 'vue3-google-login';
import axios from 'axios'
import '@fortawesome/fontawesome-free/css/all.min.css';
import ApplicationStaticConfig from "./FackApi/json/ApplicationStaticConfig.json"


let app = createApp(App)

app.config.globalProperties.$bus = eventBus; // Make it available as this.$bus


// const app = createApp(App)
const pinia = createPinia()

app.use(VueSweetalert2)
app.use(BootstrapVueNext)
app.use(VueApexCharts)
app.use(pinia)
app.use(store)
// app.use(i18n)

// *****************************************************************************************************************************************************
let domain = window.location.hostname
if (domain == "localhost") {
  domain = ApplicationStaticConfig["prepwise"].app_domain
  domain = domain.substring(domain.indexOf(".") + 1)
  domain = domain.split(".")[0]
}
else {
  domain = domain.substring(domain.indexOf(".") + 1).split(".")[0]
}

// set the application's static configs into localstorage
if (ApplicationStaticConfig[domain]) {
  store.dispatch("AppicationStaticConfig/setApplicationStaticConfig", ApplicationStaticConfig[domain])
}
else {
  // save the config of prepwise app if domain is unknown
  store.dispatch("AppicationStaticConfig/setApplicationStaticConfig", ApplicationStaticConfig[domain])
}

console.log(ApplicationStaticConfig[domain], "XXXXXXAPP Current CSS File", `./assets_gide/css/${ApplicationStaticConfig[domain].style_file}`)

// *****************************************************************************************************************************************************

// initialise the google auth options on when the domain is prepwise.com or the app environment is local
if(window.location.hostname.includes(window.location.hostname) ||
   (process.env.VUE_APP_ENV != "prod" && process.env.VUE_APP_ENV != "uat")
 ) {
  const applicationStaticConfig = store.getters["AppicationStaticConfig/getApplicationStaticConfig"];

  const gauthOption = {
    clientId: applicationStaticConfig.google_auth_client_id,
    scope: 'profile email',
    prompt: 'select_account'
  }
  app.use(vue3GoogleLogin, gauthOption);
}

app.mixin({
  data() {
    return {
      breadcrumb: true
    }
  }
})
// Global Components
app.component('iq-card', require('./components/custom/cards/iq-card').default)
app.component('loader', require('./components/custom/loader/Loader').default)
app.component('alert', require('./components/bootstrap/alert/alert').default)
app.component('carousel', require('./components/bootstrap/carousel/carousel').default)
app.component('carouselItems', require('./components/bootstrap/carousel/carouselItems').default)
app.component('toast', require('./components/bootstrap/toasts/toast').default)
app.component('toast-header', require('./components/bootstrap/toasts/toast-header').default)
app.component('toast-body', require('./components/bootstrap/toasts/toast-body').default)
app.component('progressbar', require('./components/bootstrap/Progressbar/progressbar').default)
app.component('popover', require('./components/bootstrap/popover/popover').default)
app.component('tooltip', require('./components/bootstrap/tooltip/tooltip').default)
// app.component('Lottie', require('./components/socialapp/lottie/Lottie').default)
app.component('tab-nav', require('./components/bootstrap/tab/tab-nav').default)
app.component('tab-nav-items', require('./components/bootstrap/tab/tab-nav-items').default)
app.component('tab-content', require('./components/bootstrap/tab/tab-content').default)
app.component('tab-content-item', require('./components/bootstrap/tab/tab-content-item').default)
app.component('TimeLine', require('./components/custom/timeline/TimeLine').default)
app.component('dropdown', require('./components/bootstrap/dropdown/dropdown').default)
app.component('dropdown-items', require('./components/bootstrap/dropdown/dropdown-items').default)
app.component('collapse', require('./components/bootstrap/collapse/collapse').default)
app.component('collapse-content', require('./components/bootstrap/collapse/collapse-content').default)
app.component('modal', require('./components/bootstrap/modal/modal').default)
app.component('model-header', require('./components/bootstrap/modal/model-header').default)
app.component('model-body', require('./components/bootstrap/modal/model-body').default)
app.component('model-footer', require('./components/bootstrap/modal/model-footer').default)
app.component('offcanvas', require('./components/bootstrap/offcanvas/offcanvas').default)
app.component('offcanvas-header', require('./components/bootstrap/offcanvas/offcanvas-header').default)
app.component('offcanvas-body', require('./components/bootstrap/offcanvas/offcanvas-body').default)


window.addEventListener("flutterInAppWebViewPlatformReady", function (event) {
  console.log("flutterInAppWebViewPlatformReady NOW")
})

if (navigator.userAgent.toLowerCase().includes("gide_ios")) {
  window.__IS_APP__ = true
  window.__DEVICE_OS__ = "ios"
  window.__IS__MOBILE_DEVICE__ = true
}
else if(navigator.userAgent.toLowerCase().includes("gide_android")) {
  window.__IS_APP__ = true
  window.__DEVICE_OS__ = "android"
  window.__IS__MOBILE_DEVICE__ = true
}
else if(navigator.userAgent.toLowerCase().includes("iphone")
  || navigator.userAgent.toLowerCase().includes("ipod")
  || navigator.userAgent.toLowerCase().includes("ipad")
){
  window.__IS_APP__ = false
  window.__IS__MOBILE_DEVICE__ = true
  window.__DEVICE_OS__ = "ios"
}
else if(navigator.userAgent.toLowerCase().includes("android")) {
  window.__IS_APP__ = false
  window.__IS__MOBILE_DEVICE__ = true
  window.__DEVICE_OS__ = "android"
}
else {
  window.__IS_APP__ = false
  window.__IS__MOBILE_DEVICE__ = false
  window.__DEVICE_OS__ = "web"
}

// Reload the APP if New Version is Deployed
if(process.env.VUE_APP_ENV == "prod" || process.env.VUE_APP_ENV == "uat") {
  window.onfocus = async function() {
    var VUE_APP_VERSION = localStorage.getItem("VUE_APP_VERSION")
    VUE_APP_VERSION = VUE_APP_VERSION ? VUE_APP_VERSION : process.env.VUE_APP_VERSION

    //Get the info from the Web Server
    axios({
      method: "get",
      url: "https://" + window.location.hostname + "/version",
      timeout: 1000 * 60 * 5, // Wait for 60*5 seconds
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      if(response.status === 200) {
        if (VUE_APP_VERSION !== response.data) {
          localStorage.setItem("VUE_APP_VERSION", response.data);
          window.location.reload("https://" + window.location.hostname);
        }
      }
    })
    .catch((e) => {
      console.error(e)
    })
  };
}

// connect to API_SERVICE on websocket protocol
export var socket = socketIo( process.env.VUE_APP_GIDE_API, {transports: ['websocket'], upgrade: false, secure: true });

if(socket){
  console.log("New Socket Connected", socket)
  window.socket = socket
}

socket.on("connect_error", (err) => {
  console.log(`connect_error due to ${err}`)
});

socket.on("disconnect", function() {
  console.log("Disconnected")
});

socket.on("reconnect", function() {
  console.log("Reconnecting")
});

socket.on("connect", async function() {
  console.log("Connected After Reconnect")

  let user_id = null;
  try{
    let userData = await store.getters['User/userData'];
    user_id = userData.user_id
    socket.emit('prepwise_subscribe_user_id', user_id, user_id);
  }
  catch(error){
    console.log("User Id Missing during socket reconnect")
  }
})

import socket_listener from "./Utils/socketListener";
app.config.globalProperties.$socketListener= new socket_listener(this, socket);

// route guard for Authentication

router.beforeEach(async (to, from, next) => {
  let userData = store.getters['User/userData']

  //Handle the Request from server.js:apple_signin_webhook
  if(to.query && to.query.uri && to.query.uri.includes("apple_signin_webhook")) {
    if (!userData || (userData && !userData.user_is_logged_in)) {
      //Not logged in redirect to login page.
      let redirectUri = "/login";

      //APPLE LOGIN POPUP FAILED, SO LOGIN VIA REDIRECT
      if(to.query.f){
        redirectUri += "?f="+to.query.f;
      }
      else if(decodeURIComponent(window.location.href.split("?")[1]).indexOf('uri=') !== -1){
        //Deep Link Handling for Not logged User. Redirect to the URL passed in "uri" Param
        let decodedURI = decodeURIComponent(window.location.href.split("?")[1]);
        redirectUri = '/' + decodedURI.replace('uri=', "");//We dont need the string uri=
        console.log("Found Encoded URL. Not Logged In User, Redirect To => ", redirectUri);
      }

      next({
        path: redirectUri
      })
    }
  }
  else if (to.matched.some(record => record.meta.requiresAuth) ) {
    // Check if User is Authenticated
    if (!userData || (userData && !userData.user_is_logged_in)) {
      // Not logged in redirect to login page.
      let redirectUri = '/login'
      await store.commit("DeepLink/setDeepLink", to.fullPath)

      next({
        path: redirectUri
      })
    }
    else {
      next()
    }
  }
  else if (to.matched.some(record => record.meta.requiresVisitors)) {
    if (userData && userData.user_is_logged_in) {
      next({
        path: '/home'
      })
    }
    else {
      next()
    }
  }
  else if (to.path === '/') {
    if (userData && !userData.user_is_logged_in) {
      next({
        path: '/home'
      })
    }
    else {
      next({
        path: '/login'
      })
    }
  }
  else {
    // TO be called for cases which does not need authentication
    next() // make sure to always call next()!
  }
})

app.use(router).mount('#app')

export { app }
